import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqComponent } from './faq.component';
import { DssAccordionModule } from '@dss/components/accordion';
import { DssDrawerModule } from '@dss/components/drawer';
import { DssButtonModule } from '@dss/components/button';
import { TrackingModule } from '../../directives/tracking.module';

@NgModule({
  declarations: [FaqComponent],
  imports: [
    CommonModule,
    DssAccordionModule,
    DssDrawerModule,
    DssButtonModule,
    TrackingModule,
  ],
  exports:[FaqComponent]
})
export class FaqModule { }
